//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    name: 'LegalPages',
    data() {
        return {
            specialConditions: false,
            legalAge: false,
            contactedViaPhone: false,
            contactedViaMail: false,
        };
    },
    computed: {
        ...mapState(['step', 'legal']),
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('setLegal', {
                specialConditions: this.specialConditions,
                legalAge: this.legalAge,
                contactedViaPhone: this.contactedViaPhone,
                contactedViaMail: this.contactedViaMail,
            }).then(() => this.$store.dispatch('setStep', this.step + 1));
        },
        back() {
            this.$store.dispatch('setStep', this.step - 1);
        },
    },
    created() {
        if (this.$route.query.zp == 'true') {
            this.specialConditions = true;
            this.legalAge = true;
            this.contactedViaPhone = false;
            this.contactedViaMail = false;
            this.onSubmit();
        }

        if(Object.keys(this.legal).length) {
            this.specialConditions = this.legal.specialConditions;
            this.legalAge = this.legal.legalAge;
            this.contactedViaPhone = this.legal.contactedViaPhone;
            this.contactedViaMail = this.legal.contactedViaMail;
        }
    },
};
